<div class="content">
  <div class="section-title">Inspector User ID Report</div>
  <div *ngIf="!showTable" class="tab-content" role="tabpanel" aria-hidden="true">


    <div class="add-user-form">
      <div class="user-id-verification">
        <div class="form-row">
          <label for="newUserId">User ID:</label>
          <input pInputText id="newUserId" type="text" (keydown.enter)="verifyUser()"  [(ngModel)]="newUserId" class="user-id-input">
          <div class="verification-buttons">
            <button class="verify-btn" (click)="verifyUser()">Verify User ID</button>
            <button class="clear-btn" (click)="getInspectorCaiReport()" *ngIf="userVerified && inspectorCaiReport">Run
              Report</button>
            <button class="clear-btn" (click)="clearUserID()">Clear User ID</button>

          </div>
        </div>

        <!-- Display message when user does not exists -->
        <p *ngIf="userDoesNotExist" class="verification-message">User ID does not Exists</p>

        <!-- Display user information when verified -->
        <div *ngIf="userVerified && inspectorCaiReport" class="user-info-display">
          <p class="user-email"><span>Email: </span>{{inspectorCaiReport.email}}</p>
          <p class="user-name"><span>Full Name: </span>{{inspectorCaiReport.givenName}}</p>
          <p class="user-city"><span>City: </span>{{inspectorCaiReport.city}}</p>
          <p class="user-phone"><span>Phone: </span>{{inspectorCaiReport.phoneNumber}}</p>
          <p class="user-cai"><span>{{inspectorCaiReport.cai}} Cai: </span>{{inspectorCaiReport.cai}}</p>

        </div>
      </div>
    </div>


  </div>
  <div *ngIf="noDataFound" class="error-message">
    <a (click)="return()" class="return"> Return to Search Inspector User ID </a>
    <div style="color: red; margin: 10px 0;">
      No data found.
      <div style=" color:  black;">CAI : {{userCai}}</div>
    </div>
  </div>
  <div *ngIf="showTable && !noDataFound" class="table-chart-container mt-10">
    <a (click)="return()" class="return"> Return to Search Inspector User ID </a>
    <div class="exportToExcel excel-btn">
      <div class="actions">
        <button pButton type="button" label="Export To Excel" icon="pi pi-file-excel" class="p-button-outlined"
          (click)="exportToExcel()">Export To Excel</button>
      </div>
    </div>
    <div class="report-content section-wrapper">
      <p-table [value]="inspectorCaiReportData" [paginator]="true" [rows]="10" responsiveLayout="scroll">
        <ng-template pTemplate="header">
          <tr>
            <th>Tag Number</th>
            <th>Entry Date</th>
            <th>Oper User ID</th>
            <th>Division</th>
            <th>Section</th>
            <th>Plant</th>
            <th>LDAR</th>
            <th>Op. PSI</th>
            <th>Op. Temp</th>
            <th>ShutdownDescription</th>
            <th>Service </th>
            <th>Insp User ID</th>
            <th>Service Class</th>
            <th>OA User ID</th>
            <th>Permanent Repair Date</th>
            <th>Eng User ID</th>
            <th>TLR Type</th>
            <th>Maximo WO Number</th>
            <th>Maximo Outage- T/A</th>

          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-detail>
          <tr let detail of inspectorCaiReportData>
            <td><a routerLink="/details-section/{{detail.Tag_Number}}">
                {{ detail.Tag_Number }}</a></td>
            <td>{{detail.Data_Entry_Date | date:'MM/dd/yyyy'}}</td>
            <td>{{detail.Operator_CAI}}</td>
            <td class="left-align">{{detail.Division}}</td>
            <td class="left-align">{{detail.Section}}</td>
            <td class="left-align">{{detail.Plant}}</td>
            <td class="left-align">{{detail.LDAR}}</td>
            <td>{{detail.Oper_PSI}}</td>
            <td>{{detail.Oper_Temp}}</td>
            <td class="left-align">{{detail.ShutdownDescription}}</td>
            <td>{{detail.Service}}</td>
            <td>{{detail.InspectionCAI}}</td>
            <td>{{detail.ServiceClass}}</td>
            <td>{{detail.OACAI}}</td>
            <td>
              <span class="{{detail.Permanent_Repair_Date_Color}}"> {{ detail.Permanent_Repair_Date| date: 'MM/dd/yyyy' }}</span>
            </td>
            <td>{{detail.EngineeringCAI}}</td>
            <td>{{detail.TLRType}}</td>
            <td>{{detail.Maximo_WO_Number}}</td>
            <td>{{detail.Maximo_Outage_T_A}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="17">No records found.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </div>
</div>